import { useEffect, useState } from "react"
import { fetchBalanceAsAdmin } from "../../API/AdminInfo/AdminInfo"

export const useAdminBalance = ({ showBalance }: { showBalance: boolean }) => {
    const [balance, setBalance] = useState<number | null>(null)
    const [lastUpdate, setLastUpdate] = useState<number>(0)

    const formatBalance = (balance: number | null) => {
        if (!balance) return ' -- '
        return balance.toLocaleString('es-AR', {
            style: 'currency',
            currency: 'ARS',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })
    }

    const [loadingBalance, setLoadingBalance] = useState<boolean>(false)
    const getBalance = async () => {
        if (!showBalance) return;

        const now = Date.now()
        const timeSinceLastUpdate = now - lastUpdate
        
        if (timeSinceLastUpdate < 15000) {
            return
        }

        setLoadingBalance(true)
        const balance = await fetchBalanceAsAdmin()
        if (balance?.result?.balance) {
            setBalance(balance?.result?.balance)
        }
        setLoadingBalance(false)
        setLastUpdate(now)
        return balance
    }

    useEffect(() => {
        getBalance()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showBalance])
    
    return {
        getBalance,
        balance,
        loadingBalance,
        formatBalance
    }
}
